export const BUYER_ACTION_KEYS = {
  APPLY_APPLICATION: 'apply_application',
  COMPLETE_PAYMENT: 'complete_payment',
  REVIEW_AND_COMPLETE_REQUESTS: 'review_and_complete_requests',
  SEND_PAYMENT: 'send_payment',
  VIEW_PAYMENTS: 'view_payments',
  WITHDRAW_APPLICATION: 'withdraw_application',
  WITHDRAW_INITIAL_INQUIRY: 'withdraw_initial_inquiry'
};

export const BREEDER_ACTION_KEYS = {
  ASSIGN_TO_LITTER: 'assign_to_litter',
  ASSIGN_TO_PUPPY: 'assign_to_puppy',
  EDIT_ASSIGNMENT: 'edit_assignment',
  REQUEST_BUYER_APPLICATION: 'request_buyer_application',
  REQUEST_PAYMENT: 'request_payment',
  REVIEW_APPLICATION: 'review_application',
  REVIEW_PAYMENT: 'review_payment',
  VIEW_REQUEST: 'view_request'
};

export const INLINE_PAYMENT_ACTION_KEYS = {
  ACCEPT_PAYMENT: 'Accept',
  RETURN_PAYMENT: 'Return',
  COMPLETE_REQUEST: 'Complete request',
  COMPLETE: 'Complete',
  CANCEL_REQUEST: 'Cancel request',
  CANCEL: 'Cancel'
};

export const LINK_PREVIEW_TYPES = {
  PAYMENT_POLICY: 'PaymentPolicy'
};

export const FILE_UPLOAD_INPUT_NAME = 'multi-file-upload';

export const GOODBOT_EXPERIMENT_VERSION = 'goodbot_experiment_v1';
export const PROFILE_EXPERIMENT_VERSION = 'profile_experiment_v1';
export const BUYER_APPLICATION_V2_VERSION = 'buyer_application_v2';

export const ATTACHMENT_SUMMARIES = {
  MEDIA_SHARED: 'Media shared',
  MEDIA_SENT: 'Media sent',
  APPLICATION_SENT: 'Application sent',
  APPLICATION_REQUESTED: 'Application requested',
  APPLICATION_COMPLETED: 'Application completed',
  APPLICATION_REVIEWED: 'Application reviewed',
  PAYMENT_SENT: 'Payment sent',
  PAYMENT_REQUESTED: 'Payment requested',
  PAYMENT_RETURNED: 'Payment returned',
  PAYMENT_CANCELLED: 'Payment cancelled',
  PAYMENT_COMPLETED: 'Payment completed',
  PAYMENT_ACCEPTED: 'Payment accepted',
  INSURANCE_SHARED: 'Insurance shared',
  STORY_REQUESTED: 'Story requested',
  STORY_SUBMITTED: 'Story submitted'
};

export const PAYMENT_ACTION_TYPES = {
  LINK: 'link',
  BUTTON: 'button'
};

export const MAX_UNREAD_COUNT = 20;
export const MAX_UNREAD_COUNT_DISPLAY = `${MAX_UNREAD_COUNT}+`;

export const BUYER_AGREED_TO_PAYMENT_POLICY =
  "I have agreed to Good Dog's Payment Policy";
export const SIGNATURE_REQUEST_INFO_MESSAGE_BREEDER =
  'Your contract was sent via email. We’ll notify you once your buyer completes your contract.';
export const SIGNATURE_REQUEST_INFO_MESSAGE_BUYER =
  'Contracts help protect both you and your breeder. We’ll notify you once your breeder completes your contract.';
